import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuCatalogDeletePayload,
	IActionMenuCatalogDeletePayloadDone,
	IActionMenuCatalogDeletePayloadError,
} from './types';

export const menuCatalogDelete = actionCreatorAsync<
	IActionMenuCatalogDeletePayload,
	IActionMenuCatalogDeletePayloadDone,
	IActionMenuCatalogDeletePayloadError
>(
	'menuCatalogDelete',
	async (params) => {
		const { id } = params;
		const { data } = await Api.menuCatalog.deleteItem({
			params: { id },
		});

		return data;
	},
);
